export const RepeatIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 8C1.5 6.27609 2.18433 4.62231 3.40332 3.40332C4.62231 2.18433 6.27609 1.5 8 1.5H8.00195L8.33984 1.50977C10.0233 1.59744 11.6233 2.28991 12.8408 3.4668L14.3535 4.97949C14.5487 5.1747 14.5486 5.49125 14.3535 5.68652C14.1826 5.85743 13.9187 5.87925 13.7246 5.75098L13.6465 5.68652L12.1455 4.18652L11.9326 3.99023C10.8464 3.03707 9.44964 2.50546 7.99805 2.5C6.54006 2.50052 5.14232 3.08034 4.11133 4.11133C3.07988 5.14278 2.5 6.54131 2.5 8C2.5 8.27614 2.27614 8.5 2 8.5C1.72386 8.5 1.5 8.27614 1.5 8Z"
        fill="#343A40"
      />
      <path
        d="M13.5 8C13.5 7.72386 13.7238 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8C14.5 9.72391 13.8156 11.3777 12.5966 12.5967C11.3777 13.8157 9.72387 14.5 7.99996 14.5H7.99801C6.19174 14.4932 4.45785 13.7886 3.15914 12.5332L1.64645 11.0205L1.58199 10.9414C1.4542 10.7474 1.47586 10.4842 1.64645 10.3135C1.81735 10.1426 2.08126 10.1207 2.27535 10.249L2.35348 10.3135L3.85445 11.8135L4.06734 12.0098C5.15333 12.9627 6.54967 13.4933 8.00094 13.499C9.45928 13.4988 10.8574 12.9199 11.8886 11.8887C12.9201 10.8572 13.5 9.45869 13.5 8ZM13.5 2C13.5 1.72386 13.7238 1.5 14 1.5C14.2761 1.5 14.5 1.72386 14.5 2V5.33301C14.5 5.60915 14.2761 5.83301 14 5.83301H10.667C10.3908 5.83301 10.167 5.60915 10.167 5.33301C10.1671 5.05702 10.3909 4.83301 10.667 4.83301H13.5V2Z"
        fill="#343A40"
      />
      <path
        d="M1.5 14V10.667C1.5 10.3908 1.72386 10.167 2 10.167H5.33301C5.60915 10.167 5.83301 10.3908 5.83301 10.667C5.83301 10.9431 5.60915 11.167 5.33301 11.167H2.5V14C2.5 14.2761 2.27614 14.5 2 14.5C1.72386 14.5 1.5 14.2761 1.5 14Z"
        fill="#343A40"
      />
    </svg>
  );
};
